import React from 'react';

const Mapping = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="2"
      viewBox="0 0 42 2"
      fill="none"
      {...props}
    >
      <path
        d="M0 1H42"
        stroke="currentColor"
        strokeWidth="2"
        strokeDasharray="4 4"
      />
    </svg>
  );
};

export default Mapping;
